module.exports = __webpack_public_path__ + "static/media/lead.a7e22dcc.png";